var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolution3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8933 61.0356L57.1076 61.0356C59.2773 61.0356 61.0361 59.2768 61.0361 57.1071L61.0361 13.8928C61.0361 11.7231 59.2773 9.96421 57.1076 9.96421L13.8933 9.96421C11.7236 9.96421 9.9647 11.7231 9.9647 13.8928L9.9647 57.1071C9.9647 59.2768 11.7236 61.0356 13.8933 61.0356Z",
    stroke: "url(#paint0_linear_304_47)",
    strokeWidth: 4.46226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7861 19.7856H27.6433M19.7861 29.6071H37.4647M53.179 29.6071L41.3933 49.2499L27.6433 41.3928L19.7861 53.1785",
    stroke: "url(#paint1_linear_304_47)",
    strokeWidth: 4.46226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_47",
    x1: 61.0361,
    y1: 35.4989,
    x2: 9.96673,
    y2: 35.4989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0093FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_304_47",
    x1: 19.7861,
    y1: 36.4827,
    x2: 53.1777,
    y2: 36.4827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0093FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution3);
export default __webpack_public_path__ + "static/media/solution3.dea36df67a80c9b6fef97abdd1deeb38.svg";
export { ForwardRef as ReactComponent };